import CrashlyticsEvents from 'src/logging/Crashlytics';
import PlatformApi from 'src/api/PlatformApi';
import Events from 'src/logging/Events';
import Logger from 'src/logging/Logger';
import AccountStore from 'src/stores/AccountStore';
import {Snack} from 'src/types/snack/Snack';
import {SnackAction} from 'src/types/snack/SnackAction';
import NavActions from 'src/actions/NavActions';
import AppRoutes from 'src/AppRoutes';

export const handleAcceptSnack = (snack: SnackAction) => {
  loadSnack(snack).then((result) => {
    if (result?.receiverAccountId === AccountStore.getAccountId()) {
      NavActions.navigate(AppRoutes.SnackDetail, {
        snackId: snack.snackId,
        snackLocationId: snack.locationId,
        snackAction: snack.snackAction,
      });
    }
  });
};

const loadSnack = async (snack: SnackAction): Promise<Snack> => {
  try {
    const snackDetails = await PlatformApi.loadSnackDetails(
      snack.locationId,
      snack.snackId,
    );
    Logger.Log.LogAPIEvent(
      'PlatformAPI',
      'LoadSnackDetails',
      JSON.stringify({
        locationId: snack.locationId,
        snackId: snack.snackId,
      }),
      JSON.stringify(snack),
    );
    return snackDetails;
  } catch (e) {
    CrashlyticsEvents.log(
      'Exception',
      'snack/loadSnackDetail',
      JSON.stringify(e),
      JSON.stringify(snack),
    );
    Events.Error.trackEvent(
      'Exception',
      'snack/loadSnackDetail',
      JSON.stringify(e),
    );
    return null;
  }
};
